import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { showModal } from "../../features/modal/modalSlice"
import { useScrollLock } from "../../hooks/useScrollLock"
import styled from "styled-components"
import PageTopTitle from "../shared/PageTopTitle"
import Button from "../shared/button/Btn"


const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1000px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            padding: 40px 0;
            width: 800px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin: 30px 0;
        }
    }
`

const UyeIsvereniModal = () => {

    const location = useLocation()
    const dispatch = useDispatch()

    const {modalLocation } = useSelector(state => state.modal)
    const { uyeIsvereni } = useSelector(state => state.uyelerAraclar)
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])
    
    const titles = ["#","Adı Soyadı", "Telefon Numarası", "E-Yurt ID"]

    if(!uyeIsvereni){
        return null
    }
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Üye İşlemleri"}/>
        <div className="content">
        </div>
        <div className='button-grp'>
        <Button color={"#E85546"} width="220px" radius={"10px"} padding="0 10px" handleClick={()=> dispatch(showModal(null))}>Geri Dön</Button>
    </div>
    </div>
</ModalContainer>
  )
}

export default UyeIsvereniModal